// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b8d8fd0","486":"349e1431","620":"54da811b","791":"18be87c8"}[chunkId] + ".chunk.js";
};